! function() {
    "use strict";
    customElements.get("press-component") || customElements.define("press-component", class extends HTMLElement {
        constructor() {
            super(),
            this.slider = this.querySelector("[data-press-items]"),
            this.sliderNav = this.querySelector("[data-logo-slider]"),
            this.checkSlidesEvent = () => this.checkSlides(),
            this.sliderResizeEvent = () => this.resizeSlider()
        }

        connectedCallback() {
            // ✅ FIX: wait for full page load
            window.addEventListener("load", () => {
                this.initSlider();
                setTimeout(() => this.checkSlides(), 400);
            });

            document.addEventListener("theme:resize:width", this.checkSlidesEvent);
            document.addEventListener("theme:resize:width", this.sliderResizeEvent);
        }

        checkSlides() {
            const e = this.closest("section").offsetWidth,
                t = this.querySelectorAll("[data-logo-slide]"),
                i = window.theme.Flickity.data(this.sliderNav) || null;

            if (i !== null) {
                i.options.draggable = !1;
                i.options.wrapAround = !1;
                i.options.contain = !0;

                if (this.getSlidesWidth() > e && t.length > 2) {
                    i.options.draggable = !0;
                    i.options.wrapAround = !0;
                    i.options.contain = !1;
                }

                i.resize();
                i.updateDraggable();
            }
        }

        getSlidesWidth() {
            const e = this.querySelectorAll("[data-logo-slide]");
            let t = 0;
            e.length && e.forEach((e => {
                t += e.offsetWidth;
            }));
            return t;
        }

        initSlider() {
            let e = window.theme.Flickity.data(this.slider) || null,
                t = window.theme.Flickity.data(this.sliderNav) || null;

            const i = parseInt(this.dataset.duration),
                s = "true" === this.dataset.autoplay && i;

            // ✅ MAIN SLIDER
            e = new window.theme.Flickity(this.slider, {
                fade: !0,
                wrapAround: !0,
                adaptiveHeight: !1,
                prevNextButtons: !1,
                pageDots: !0,
                autoPlay: s
            });

            // ✅ LOGO SLIDER
            t = new window.theme.Flickity(this.sliderNav, {
                draggable: !1,
                wrapAround: !1,
                contain: !0,
                imagesLoaded: !0,
                asNavFor: this.slider,
                prevNextButtons: !1,
                adaptiveHeight: !1,
                pageDots: !1
            });

            // ✅ SMOOTH MARQUEE
            setTimeout(() => {
                const isSliderEnabled = t.options.wrapAround || t.options.draggable;
                if (!isSliderEnabled) return;

                let speed = 0.5;

                t.options.friction = 1;
                t.options.selectedAttraction = 0;
                t.options.freeScroll = true;

                t.stopPlayer && t.stopPlayer();

                const totalWidth = t.slideableWidth;

                const smoothMarquee = () => {
                    if (!t) return;

                    if (t.isPointerDown) {
                        requestAnimationFrame(smoothMarquee);
                        return;
                    }

                    t.x -= speed;

                    if (Math.abs(t.x) >= totalWidth / 2) {
                        t.x += totalWidth / 2;
                    }

                    t.settle(t.x);
                    t.positionSlider();

                    requestAnimationFrame(smoothMarquee);
                };

                smoothMarquee();

                this.sliderNav.addEventListener('mouseenter', () => speed = 0);
                this.sliderNav.addEventListener('mouseleave', () => speed = 0.35);

            }, 600); // ✅ FIX: increased delay (Safari safe)

            // ✅ SYNC
            t.on("change", (index => {
                e.selectCell(index);
            }));

            e.on("change", (index => {
                e.cells.forEach(((cell, i) => {
                    cell.element.querySelectorAll("a, button").forEach((el => {
                        el.setAttribute("tabindex", i === index ? "0" : "-1");
                    }));
                }));
            }));

            window.theme.flickitySmoothScrolling(this.slider);
            window.theme.flickitySmoothScrolling(this.sliderNav);
        }

        resizeSlider() {
            const e = window.theme.Flickity.data(this.slider) || null,
                  t = window.theme.Flickity.data(this.sliderNav) || null;

            // ✅ FIX: no re-init here
            if (e && t) {
                e.resize();
                t.resize();
            }
        }

        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.checkSlidesEvent);
            document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
        }
    })
}();